module.exports = function(posts) {
	'use strict';
	posts.directive('recommendedNewsModal',recommendedNewsModal);
	recommendedNewsModal.$inject=['$rootScope'];
	function recommendedNewsModal($rootScope) {
		return {
			restrict: 'E',
			scope: {
        currentPostObj:"="
		  },
		 	template: require('./partial/recommendedNews.html'),
		  link: function (scope, element, attrs) {
        $rootScope.modalShow = true;
        scope.cancelRecommendedNewsModal = function() {
          $rootScope.modalShow = false;
          scope.currentPostObj.recommendedNewsModalShow = false;
        }
        scope.removeItem = function(index) {
          scope.currentPostObj.recommendedNews.splice(index,1); 
        }
        scope.sortableRecomemendedOptions= {
          axis: 'y'
        }
			}    
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/recommendedNewsDirective.js
// module id = 560
// module chunks = 0